import { useCurrentDoseView } from '~/hooks/dose/useCurrentDose';
import { OverlayLabel } from '~/components/OverlayLabel';

/**
 * Shows whether the dose currently rendered in the viewport is imported
 * from DICOM or AI-generated. Rendered inline inside the colorwash
 * overlay row above the Max/Normalized labels.
 */
const DoseOriginLabel = () => {
    // The projection is undefined whenever no dose is selected, so this
    // single guard covers both "no dose" and "dose not yet resolvable".
    const doseData = useCurrentDoseView();

    if (!doseData) {
        return null;
    }

    const isAiGenerated = doseData.generated === true;

    return (
        <OverlayLabel data-testid="dose-origin-label">
            {isAiGenerated ? 'AI Generated Dose' : 'Imported Dose'}
        </OverlayLabel>
    );
};

export default DoseOriginLabel;
